import React from 'react';

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Edho Zell',
      title: 'CEO',
      image: 'https://i.ibb.co.com/SwzbBtw2/ot1.webp',
    },
    {
      name: 'Abibayu Gustri Kamadjaja',
      title: 'VP Social Bread Enterprise',
      image: 'https://i.ibb.co.com/ZRH5zqQ2/ott2.webp',
    },
  ];

  return (
    <section id="our_team" className="tw-py-16 md:tw-py-24">
    <div className="tw-container tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-text-center tw-mb-16">
        <h2 className="tw-text-3xl md:tw-text-5xl tw-font-bold tw-text-dark tw-mb-4 title-gradient">Our Team</h2>
        <p className="tw-text-gray-600 tw-max-w-3xl tw-mx-auto">Lead by a digital marketing expertise for more than 10 years experience, as well as a broad connections, lots of great insight and exciting ideas making.</p>
        </div>

        <div className="inner_start">
        <div className="tw--mx-4 tw-flex tw-flex-wrap tw-justify-center">
            {teamMembers.map((member, index) => (
            <div key={index} className="tw-w-full tw-px-4 md:tw-w-1/2 xl:tw-w-1/4">
                <div className="tw-mx-auto tw-mb-10 tw-w-full tw-max-w-[370px]">
                <div className="tw-relative tw-overflow-hidden tw-rounded-lg">
                    <img src={member.image} alt="image" className="tw-w-full tw-object-contain tw-h-[365px]" />
                    <div className="tw-absolute tw-bottom-2 tw-left-0 tw-w-full tw-text-center">
                    <div className="tw-relative tw-mx-5 tw-overflow-hidden tw-rounded-lg tw-bg-white tw-px-3 tw-py-5 dark:tw-bg-dark-2">
                        <h3 className="tw-text-base tw-font-semibold tw-text-dark dark:tw-text-white">{member.name}</h3>
                        <p className="tw-text-xs tw-text-body-color dark:tw-text-dark-6">{member.title}</p>
                        <div>
                        <span className="tw-absolute tw-bottom-0 tw-left-0">
                            <svg
                          width="61"
                          height="30"
                          viewBox="0 0 61 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <circle
                            cx="16"
                            cy="45"
                            r="45"
                            fill="#13C296"
                            fill-opacity="0.11" />
                        </svg>
                        </span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            ))}
        </div>
        </div>
    </div>
    </section>
  );
};

export default TeamSection;